import React from "react";
import { EditDeploymentFreeze } from "./EditDeploymentFreeze";
interface EditDeploymentFreezePageProps {
    deploymentFreezeId: string;
}
export function EditDeploymentFreezePage({ deploymentFreezeId }: EditDeploymentFreezePageProps) {
    return <EditDeploymentFreeze create={false} deploymentFreezeId={deploymentFreezeId}/>;
}
